// User Story 52899: Research: Investigate and resolve issues building the React app with Vitel
// SPR - Removed all the module crap because it isn't compatible with Vite

// ********** IMPORTANT **********
// ********** IF THIS FILE IS CHANGED THE CHANGES MUST BE PORTED TO THE BACKEND INTO THE Backend\Components\HighCharts\plotline-image.js FILE **********
// On the Backend Phantomjs.exe does not like let in strict mode so we must use var instead of let.


/**
* Plotline Image v1.0.0 (2022-03-03)
*
* (c) 2022 eLynx Technologies LLC
*
* License: eLynx Technologies LLC (CC)
*/

// Tell eslint that Highcharts and define will be defined somewhere else
/* global Highcharts define */

/**
 * @namespace highcharts-plotline-image
 **/

// ******************* BEGIN NOTES *******************

// Reference highcharts-custom-events for the pattern used below.

// Wrap like a Highcharts Typescript Plugin.
// https://github.com/highcharts/rounded-corners/blob/master/rounded-corners.js


// Load with React and Typescript
// https://stackblitz.com/edit/react-gl7yun

// ***** Dan https://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/tooltip/trackball-plugin/
// Shows that
// (function (H: any) {
// can contain both H.wrap instances below.

// ******************* END NOTES *******************

// (function (factory) {

//     if (typeof module === 'object' && module.exports) {
//         factory['default'] = factory;
//         module.exports = factory;
//     } else if (typeof define === 'function' && define.amd) {
// 		define('highcharts-plotline-image', ['highcharts'], function (Highcharts) {
//             factory(Highcharts);
//             factory.Highcharts = Highcharts;
//             return factory;
//         });
//     } else {
//         factory(Highcharts);
//     }
// }(
    
    
export default function plotlineImage(HC) {

    const highChartsVersion = +HC.version.replace(/\./g, '');

    // Make sure the plugin only attaches to a Highcharts instance one time.
    if (HC.plImagePluginAttached === undefined || HC.plImagePluginAttached === null) {

        HC.wrap(HC.Axis.prototype, 'getPlotLinePath', function (proceed, value, lineWidth, old, force, translatedValue) {

            // Apply the original function with the original arguments, 
            // which are sliced off this function's arguments
            const plotLinePath = proceed.apply(this, Array.prototype.slice.call(arguments, 1));

            if (plotLinePath !== undefined && plotLinePath !== null) {

                // This can only be set for all plotlines.
                if (this.options.plotLineMarginTop !== undefined && this.options.plotLineMarginTop !== null) {

                    if (Array.isArray(plotLinePath)) {

                        if (plotLinePath.length === 2 && Array.isArray(plotLinePath[0]) && plotLinePath[0].length === 3) {

                            // Highchart version 8.1.0 and above
                            // 0: ['M', x1, y1]
                            // 1: ['L', x2, y2]
                            plotLinePath[0][2] += this.options.plotLineMarginTop;

                        } else {

                            // Before Highcharts version 8.1.0
                            //  ['M', x1, y1, 'L', x2, y2],]
                            plotLinePath[2] += this.options.plotLineMarginTop !== undefined && this.options.plotLineMarginTop !== null ? this.options.plotLineMarginTop : 0;
                        }
                    }
                }
            }

            return plotLinePath;
        });

        HC.wrap(HC.PlotLineOrBand.prototype, 'render', function (proceed) {

            // Apply the original function with the original arguments, 
            // which are sliced off this function's arguments
            const plotLine = proceed.apply(this, Array.prototype.slice.call(arguments, 1));

            // If we have an image element, remove it so that zooms and resizes work. The image will be recreated in the appropriate spot below.
            if (plotLine.imageSvgElem !== undefined && plotLine.imageSvgElem !== null) {
                plotLine.imageSvgElem.destroy();
                plotLine.imageSvgElem = null;
            }

            if ((plotLine.options.isPlotLine !== undefined && plotLine.options.isPlotLine !== null && plotLine.options.isPlotLine === true) &&
                (plotLine.options.imagePath !== undefined && plotLine.options.imagePath !== null && plotLine.options.imagePath.length > 0) &&
                (plotLine.svgElem !== undefined && plotLine.svgElem !== null && plotLine.svgElem.visibility !== "hidden") &&
                (plotLine.svgElem.d !== undefined && plotLine.svgElem.d !== null) &&
                (plotLine.imageSvgElem === undefined || plotLine.imageSvgElem === null)) {

                const imageHeight = plotLine.options.imageHeight !== undefined && plotLine.options.imageHeight !== null ? plotLine.options.imageHeight : 15;
                const imageWidth = plotLine.options.imageWidth !== undefined && plotLine.options.imageWidth !== null ? plotLine.options.imageWidth : 15;
                const imageCenter = imageWidth / 2;

                //            var d = plotLine.svgElem.d.split(' ');
                const x = parseFloat(plotLine.svgElem.d.split(' ')[1]) - imageCenter;
                const y = parseFloat(plotLine.svgElem.d.split(' ')[2]) - imageHeight -
                    (plotLine.options.imageBottomMargin !== undefined && plotLine.options.imageBottomMargin !== null ? plotLine.options.imageBottomMargin : 2);

                //var newImage = plotLine.axis.chart.renderer.image('https://www.highcharts.com/samples/graphics/sun.png', x, y, imageWidth, imageHeight);
                const newImage = plotLine.axis.chart.renderer.image(plotLine.options.imagePath, x, y, imageWidth, imageHeight);
                plotLine.imageSvgElem = newImage;
                newImage.zIndex = plotLine.options.imageZindex !== undefined && plotLine.options.imageZindex !== null ? plotLine.options.imageZindex : 999999;

                // Plotline events are on different properties after Highcharts version 9.0.1
                if (highChartsVersion > 901 && plotLine.options.events !== undefined &&
                    plotLine.options.events !== null) {

                    newImage.element.onmousemove = plotLine.options.events.mousemove;
                    newImage.element.onmouseover = plotLine.options.events.mouseover;
                    newImage.element.onmouseout = plotLine.options.events.mouseout;

                    // Alternate way to add events. Is it better?
                    //newImage.on('mouseover', plotLine.options.events.mouseover)
                    //    .on('mouseout', plotLine.options.events.mouseout);

                    // SVG Image elements are different after Highcharts version 9.0.1 so this plugin must
                    //  add a property to store the plotline instance so we can get to the plotline instance later.
                    // In older versions this was the plotline instance
                    newImage.element.plotline = plotLine;

                } else {

                    newImage.element.onmousemove = plotLine.svgElem.element.onmousemove;
                    newImage.element.onmouseover = plotLine.svgElem.element.onmouseover;
                    newImage.element.onmouseout = plotLine.svgElem.element.onmouseout;
                }

                newImage.add(plotLine);
            }

            return plotLine;
        });

        HC.plImagePluginAttached = true;
    }
}

// ));

// this solves the Typescript build problem of no deftault export
// but when the code is run, there is an error that Highcharts is not defined
// in line 51
// export default factory;